import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { ExposedAPI } from "../../apis/ExposedAPI";
import { slugify } from "../../utils/utils";

export default function ArticleRedirect() {
  const { articleId } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    async function getArticle() {
      await ExposedAPI.getArticle(articleId)
        .then((res) => {
          setArticle(res.article[0]);
        })
        .catch(() => setNotFound(true));
    }
    getArticle();
  }, [articleId]);

  if (notFound) return <div>Article introuvable</div>;
  if (article)
    return (
      <Navigate
        to={`/${slugify(article.cat_label)}/${slugify(
          article.sc_label
        )}/${slugify(article.usc_label)}/${slugify(
          article.slug
        )}`}
        replace
      />
    );

  return <div>Redirection...</div>;
}
